'use client';

import * as React from 'react';

import { cn } from '@/lib/utils';

import * as AvatarPrimitive from '@radix-ui/react-avatar';

function Avatar({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn('relative flex size-8 shrink-0 overflow-hidden rounded-full', className)}
      {...props}
    />
  );
}

type AvatarImageProps = React.ComponentProps<typeof AvatarPrimitive.Image> & {
  loading?: 'eager' | 'lazy';
};
function AvatarImage({ className, ...props }: AvatarImageProps) {
  // Prefer an explicit loading prop if provided, otherwise default to lazy
  const loadingProp = props.loading ?? 'lazy';
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn('aspect-square size-full', className)}
      {...props}
      loading={loadingProp}
    />
  );
}

function AvatarFallback({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn('bg-muted flex size-full items-center justify-center rounded-full', className)}
      aria-hidden={true}
      {...props}
    />
  );
}

export { Avatar, AvatarFallback, AvatarImage };
